<template>
  <div
    class="border-2 border-gray-200 p-4 rounded-lg flex flex-col items-center gap-2"
  >
    <div
      class="text-center font-semibold uppercase leading-none tracking-wider text-gray-600"
    >
      {{ label }}
    </div>
    <div :class="[dense ? 'text-xl' : 'text-5xl']" class="grow font-bold">
      <span v-if="loading" class="animate-pulse">--</span>
      <span v-else-if="stat !== null">
        <slot>{{ stat }}</slot>
      </span>
      <span v-else> N/A </span>
    </div>
  </div>
</template>

<script setup>
defineProps({
  stat: { type: [String, Number], required: false },
  label: { type: String, required: true },
  loading: { type: Boolean, required: true },
  dense: { type: Boolean, required: false, default: false },
});
</script>
